export default "__VITE_ASSET__jdYYEKNy__"